var createGenerateRolls = function (random) { return function (numDice, diceSize) {
    var rolls = [];
    for (var i = 0; i < numDice; i++) {
        rolls.push(random(1, diceSize));
    }
    return rolls;
}; };
export default createGenerateRolls;
